import styled from 'styled-components'

const TwoStepPaymentFormStepHeaderHeadlinesUi = styled.div`
  display: block;
  flex-basis: calc(80% - 30px);
`

export default TwoStepPaymentFormStepHeaderHeadlinesUi
